export enum CommissionStatusType {
  NotPaid = "NotPaid",
  Paid = "Paid",
  Rejected = "Rejected"
}
